import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { normalizeError } from "@/store/helpers/errorHelper";

export interface VoidChequeInfo {
  errors: unknown;
}

@Module({ namespaced: true, name: "VoidChequeModule" })
export default class VoidChequeModule
  extends VuexModule
  implements VoidChequeInfo
{
  errors = {};

  get getError() {
    const [errorName] = Object.keys(this.errors);
    const error = this.errors[errorName];
    return error;
  }

  @Mutation
  [Mutations.SET_ERROR](errorObj) {
    this.errors = normalizeError(errorObj);
  }

  @Action
  [Actions.DOWNLOAD_VOID_CHEQUE](id) {
    return ApiService.downloadFile(`/void_cheques/${id}/download`)
      .then((response) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return response;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }

  @Action
  [Actions.APPROVE_VOID_CHEQUE](id) {
    return ApiService.patch(`/void_cheques/${id}/approve`, {})
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }

  @Action
  [Actions.REJECT_VOID_CHEQUE](id) {
    return ApiService.patch(`/void_cheques/${id}/reject`, {})
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }

  @Action
  [Actions.DELETE_VOID_CHEQUE](id) {
    return ApiService.delete(`/void_cheques/${id}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }
}
